'use strict';

const autocompleteService = [
  '$q',
  '$http',

  function ($q, $http) {
    var locations_url = 'https://d14w0rz7s8v3pz.cloudfront.net/predictions';
    var details_url = 'https://d14w0rz7s8v3pz.cloudfront.net/details';

    delete $http.defaults.headers.common['X-Requested-With'];
    return {
      getPlacePredictions: function (string) {
        return $http.get(locations_url + '?s=' + string, {responseType: 'json'});
      },
      getPlaceDetails: function (place_id) {
        return $http.get(details_url + '?placeId=' + place_id, {responseType: 'json'});
      }
    };
  }
];

export default autocompleteService;



// WEBPACK FOOTER //
// ./app/src/services/autocomplete_service.js